import { useEffect } from 'react';
import { useUser, useUserDispatchers } from '../../../state/user';
import { useApp, useAppDispatchers } from '../../../state/app';

import { storageAvailable } from '../../../helpers';

const useSessionData = () => {
  const { registeredUser, preregisteredUser } = useUser();
  const { registrationToken } = useApp();
  const { setPreregisteredUser } = useUserDispatchers();
  const { getUser } = useAppDispatchers();

  useEffect(() => {
    if (storageAvailable('sessionStorage')) {
      const jwt = sessionStorage.getItem('jwt');
      const userCompleted = sessionStorage.getItem('userCompleted');
      const authToken = sessionStorage.getItem('authToken');
      const preregisteredUserFromStorage =
        sessionStorage.getItem('preregisteredUser');

      if (userCompleted) {
        if (authToken) {
          getUser(authToken);
        } else if (jwt) {
          getUser(jwt);
        }
      }
      if (preregisteredUserFromStorage && !preregisteredUser) {
        setPreregisteredUser(JSON.parse(preregisteredUserFromStorage));
      }
    }
  }, []);

  useEffect(() => {
    if (storageAvailable('sessionStorage') && registeredUser) {
      sessionStorage.setItem('jwt', registrationToken);
    }
  }, [registeredUser]);
};

export default useSessionData;
